<template>
    <section class="login">
        <div class="log_row">
            <div class="log_col">
                <img class="log_img" src="@/assets/img/log.png" alt="login">
            </div>
            <div class="log_col">
                <div class="log_head">
                    <h1>Chefpolis</h1>
                    <h3>Comunidad de cocineros</h3>
                </div>
                <div class="log_form">
                    <div class="msn msn_error login_msg" v-if="errorMsg">
                        <i class="f1-cerrar"></i>
                        <p>{{errorMsg}}</p>
                    </div>
                    <form @submit.prevent="onLogin">
                        <c-input type="text" id="l_email" :field="$v.login.email" classes="mdi mdi-account-outline"
                                 length="50" placeholder="Correo electrónico"/>
                        <c-input type="password" id="l_password" :field="$v.login.password"
                                 classes="mdi mdi-lock-outline"
                                 length="20" placeholder="Contraseña"/>
                        <div class="grupo_boton">
                            <button class="btn">Ingresar</button>
                        </div>
                    </form>
                    <i class="dm-wize detalle_admin"></i>
                </div>
            </div>
        </div>
    </section>

</template>
<script>
import CInput from './common/CInput.vue'
import {email, required} from 'vuelidate/lib/validators'
import {AUTH_REQUEST} from "../store/actions/auth";
import {loading} from '../util/util'

export default {
    components: {
        CInput
    },
    data() {
        return {
            login: {
                email: null,
                password: null,
                rememberMe: false,
            },
            errorMsg: null,
            successMsg: null,
        }
    },
    validations: {
        login: {
            email: {required, email},
            password: {required},
        },
    },
    methods: {
        async onLogin() {
            const self = this;
            self.$v.login.$touch();
            if (self.$v.login.$error) return;
            self.errorMsg = null;
            loading(true);
            self.$store.dispatch(AUTH_REQUEST, {
                username: self.login.email,
                password: self.login.password
            }).then(() => {
                self.$router.push({name: 'dashboard'});
            }).catch((errorMsg) => {
                self.errorMsg = errorMsg;
            }).finally(() => {
                loading(false);
            });
        },
        redirectNext() {
            const self = this;
            if (self.$route.query.redirect)
                self.$router.push({name: self.$route.query.redirect});
            else
                self.$router.push({name: 'dashboard'});
        },
    },
    mounted() {
        const self = this;

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue